/**
 * Formatage de la température basale pour l'affichage.
 *
 * Un relevé porte soit une valeur absolue (`basal_temperature`), soit un écart à
 * l'habitude (`basal_temperature_delta`) — jamais les deux, le formulaire n'en
 * remplit qu'un. Le backend ramène les deux à une même série pour la détection du
 * décalage thermique ; ici on restitue simplement ce qui a été saisi.
 */

/** Écart signé, lisible : `+0,3 °C`, `−0,2 °C`, ou `habituelle` pour zéro. */
export function formatTempDelta(delta) {
  if (delta == null) return null;
  if (delta === 0) return 'habituelle';
  // Signe moins typographique (U+2212) et non trait d'union : sur un chiffre, le
  // tiret court se lit mal et s'aligne mal.
  const sign = delta > 0 ? '+' : '−';
  return `${sign}${Math.abs(delta).toFixed(1).replace('.', ',')} °C`;
}

/** Libellé d'un relevé, quel que soit son format de saisie. `null` si vide.
 *
 * Une mesure signalée comme perturbée (nuit blanche, fièvre, alcool) est affichée
 * telle quelle, mais annotée : le moteur l'exclut du calcul du plateau thermique et
 * l'écran ne doit pas laisser croire qu'elle compte.
 */
export function formatTemperature(entry) {
  const value = entry?.basal_temperature != null
    ? `${entry.basal_temperature} °C`
    : formatTempDelta(entry?.basal_temperature_delta);
  if (value == null) return null;
  return entry?.temperature_disturbed ? `${value} (perturbée)` : value;
}
